var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"Navbar"},[_c('div',{staticClass:"logo_container"},[_c('img',{attrs:{"src":require("@/assets/images/rocketprint-logo.png"),"alt":"Rocket Print logo"},on:{"click":_vm.goToHome}})]),_c('MobileMenu'),_c('Menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }